<i18n lang="yaml">
en:
  prediction: 'Stable rating outlook.'
ru:
  prediction: 'Прогноз по&nbsp;рейтингу&nbsp;&mdash; стабильный.'
</i18n>

<template>
  <div class="investors-widget">
    <a
      href="https://www.raexpert.ru/releases/2020/dec04/"
      class="investors-widget__item"
      rel="noopener noreferrer"
      target="_blank"
    >
      <h4 class="investors-widget__title">ruA</h4>
      <p class="investors-widget__date">
        04.12.2020
      </p>
      <p
        class="investors-widget__predict"
        v-html="$t('prediction')"
      ></p>

      <img
        v-lazy-load
        class="investors-widget__img my-auto"
        :data-src="require('~/assets/images/investors/ExpertLogo.png')"
        alt=""
      >
    </a>
    <a
      href="https://www.acra-ratings.ru/press-releases/2193"
      class="investors-widget__item"
      rel="noopener noreferrer"
      target="_blank"
    >
      <h4 class="investors-widget__title">А(RU)</h4>
      <p class="investors-widget__date">
        01.12.2020
      </p>

      <p
        class="investors-widget__predict"
        v-html="$t('prediction')"
      ></p>

      <svg
        class="investors-widget__img"
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 0 124 32"
      >
        <path
          d="M110.385,31l-1.571-4H98l-1.6,4H86.964L99.205,1h8.714L120.2,31h-9.819Zm-4.8-12.443-2.168-7.075-2.21,7.075-0.447,1.364h5.287ZM80,21H75L74.984,31h-9V1H80a10.691,10.691,0,0,1,7.711,2.9A9.233,9.233,0,0,1,91,11a8.846,8.846,0,0,1-3.289,6.877A10.834,10.834,0,0,1,80,21ZM79,8H74.984v6H79a2.916,2.916,0,0,0,3-3A2.942,2.942,0,0,0,79,8ZM54,31L44,18,43.984,31h-9V1h9L44,13,52,1H63L53,15,65,31H54ZM22.813,27H12l-1.6,4H0.963L13.205,1h8.714L34.2,31H24.385Zm-3.232-8.445-2.168-7.075L15.2,18.555,14.756,19.92h5.287Z"
        ></path>
      </svg>

    </a>
  </div>
</template>

<script>
export default {
  name: 'InvestorsWidget'
}
</script>

<style lang="scss">
.investors-widget {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 32px;
  width: 100%;
  padding: 12px 0 8px;

  @media (max-width: $breakpoint-xl) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}

.investors-widget__item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: $primary;

  @include text--sm;

  @media (max-width: $breakpoint-xl) {
    &:not(:last-child) {
      margin-bottom: 24px;
      padding-bottom: 24px;
      border-bottom: 1px solid $primary10;
    }
  }

  img {
    max-width: 100%;
  }
}

.investors-widget__title {
  font-size: 48px;
  line-height: 60px;
  font-weight: 400;
  margin-bottom: 8px;
}

.investors-widget__date {
  color: $primary;
  margin-bottom: 4px;
}

.investors-widget__predict {
  margin-bottom: 20px;
  color: $primary65;
}

.investors-widget__img {
  max-height: 32px;
}
</style>